export default __webpack_public_path__ + "media/images/front/search/search_calendar-17b02968a3baadc18fd2593aad759779.png";